import React, {useEffect} from 'react'
import {useNavigation} from '../../utils/navigation'
import EditPage from '../../Components/EditPage'
import InfoCard from '../../Components/InfoCard'
import classNames from 'classnames'
import styles from '../../../CSS/main.css'
import EditWebsiteForm from './Form'
import {WebsiteFormState} from './types'
import {useFormik} from 'formik'
import {Website} from '../../Components/List/Item/SitesItem'
import {ModerationMode} from "../../../../types";
import {useParams} from "react-router-dom";
import {getWebsiteById, updateWebsiteSettings} from "../../api/requests";
import {useAsync, useAsyncCallback} from "react-async-hook";

const useWebsiteState = (id: string) => {
  const {goBack} = useNavigation()
  const fetchWebsite = useAsync<Website>(getWebsiteById, [id])
  const updateWebsite = useAsyncCallback(updateWebsiteSettings)

  const initialFormState: WebsiteFormState = {
    disabled: 'false',
    moderationMode: ModerationMode.NONE
  }

  const formik = useFormik<WebsiteFormState>({
    initialValues: initialFormState,
    onSubmit: async (values) => {
      await updateWebsite.execute({
        moderationMode: values.moderationMode,
        disabled: values.disabled === 'true',
        domain: fetchWebsite.result.name
      })
      goBack();
    },
  })

  useEffect(() => {
    formik.resetForm({
      values: {
        disabled: fetchWebsite.result?.disabled ? 'true' : 'false',
        moderationMode: fetchWebsite.result?.moderationMode || ModerationMode.NONE
      }
    })
  }, [fetchWebsite.result])

  return {
    website: fetchWebsite.result,
    formik,
    goBack
  }
}

const EditWebsite: React.VFC = () => {
  const {id} = useParams<{ id: string }>()

  const {website, formik, goBack} = useWebsiteState(id)

  if (!website) {
    return null
  }

  return (
    <EditPage
      title={'Website settings'}
      onSave={formik.submitForm}
      onCancel={goBack}>
      <InfoCard
        iconBlock={
          <div
            className={classNames([
              website.disabled
                ? styles.WebsiteDisabled
                : styles.WebsiteEnabled
            ])}
          />
        }>
        <div className={styles.InfoBig}>{website.name}</div>
        <p className={classNames([styles.InfoSmall, styles.Ellipsis])}>
          URL:{' '}
          <b>
            <a href={website.url} target='_blank'>
              {website.url}
            </a>
          </b>
        </p>
        <p className={styles.InfoSmall}>
          Comments: <b>{website.disabled ? 'Disabled' : 'Enabled'}</b>
        </p>
      </InfoCard>
      <EditWebsiteForm
        formState={formik.values}
        handleChange={formik.handleChange}
        deleteSite={() => null}
      />
    </EditPage>
  )
}

export default EditWebsite
